export const error = {
  message: "This page may be broken but thankfully we're a healthcare ministry so we are taking it to the doctor!",
  no_program_data_assistance: 'If you need assistance now, please reach out to our <nobr>Member Services</nobr>.',
  no_program_data_message: 'We are having difficulties retrieving <nobr>your data</nobr>.',
  timeout_contact_us: 'In the meantime, please try refreshing the page or reach out to our <nobr>Member Services</nobr>:',
  timeout_message: 'We are having difficulties retrieving your data or completing your request. Our team of engineers is looking into this.',
  timeout_title: 'Oops, something went wrong',
  title: 'Oh, no!',
} as const;

export type ErrorNamespace = Record<keyof typeof error, string>;
